import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { postCommonReceipt } from "../../api/common";
import { GuestOrderFind } from "../../api/order";
import { failAlert } from "../../common/alert";
import { priceComma } from "../../common/splicePrice";
import { autoPhoneFormat } from "../../common/util/checkout-validation";
import {
  CartProductsMobile,
  CartProductsWrapper,
} from "../../components/cart/cart-styles";
import {
  FormBasicBtn,
  FormInputBasicInput,
  FormInputBasicSpan,
  FormInputRow,
  ProductMobileImg,
  ProductMobileInfo,
} from "../../components/checkout/checkout-styles";
import Layout from "../../components/layout/Layout";
import OrderCancelModal from "../../components/mypage/order/OrderCancelModal";
import * as Details from "../../components/mypage/order/OrderDetails-styles";
import OrderTrackingModal from "../../components/mypage/order/OrderTrackingModal";
import { connect } from "react-redux";
import { random } from "lodash";
import { SeoMeta } from "@/utils/seo/SeoMeta";
import { useBannerStore } from "@store/useBannerStore";

const OrderSearchPage = ({ dummyList }) => {
  const router = useRouter();
  const { bannerList, interview } = useBannerStore((s) => s);
  const [orderInfo, setOrderInfo] = useState({});
  const [orderList, setOrderList] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [dummyData, setDummyData] = useState({});
  const [deliveryList, setDeliveryList] = useState([]);
  const [openTrackingModal, setOpenTrackingModal] = useState(false);
  const [openOrderCancelModal, setOpenCancelModal] = useState(false);
  const [cancelOrdernum, setCancelOrdernum] = useState();
  const [interviewBanner, setInterviewBanner] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);

  // 배송 조회 모달 보여주기
  const onClickOrderTrackingModal = (el) => {
    setSelectedOrder(el);
    setOpenTrackingModal((prev) => !prev);
  };

  const onChangeOrderInfo = (key) => (e) => {
    setOrderInfo({ ...orderInfo, [key]: e.target.value });
  };

  const fetchDummyList = async () => {
    const deliveryDummyList = dummyList?.delivery;
    const orderStatusDummyList = dummyList?.order_status;
    let tempArr = [];
    for (const key in deliveryDummyList) {
      tempArr.push({
        value: key,
        label: deliveryDummyList[key],
      });
    }
    setDeliveryList(tempArr);
    let statusTempArr = [];
    for (const key in orderStatusDummyList) {
      statusTempArr.push({
        value: key,
        label: orderStatusDummyList[key],
      });
    }
    setOrderStatus(statusTempArr);
  };

  // 주문조회
  const findOrder = async () => {
    if (Object.values(orderInfo).includes(undefined)) {
      failAlert("정보를 모두 입력해주세요.");
      return;
    }
    const body = {
      modes: "GuestOrderFind",
      ...orderInfo,
    };
    const res = await GuestOrderFind(body);
    if (res.Code === "0000") {
      setOrderList(res.Data?.Data);
    } else {
      failAlert(res.Data?.Msg || "조회에 실패했습니다.");
    }
  };

  // deliveryList 에서 현재 value 와 비교 후 label 을 찾는 함수
  const getLabelFromDeliveryList = (data) => {
    if (deliveryList !== undefined) {
      return deliveryList.find((el) => el.value === data)?.label;
    }
  };

  // orderStatus 에서 현재 value 와 비교 후 label 을 찾는 함수
  const getLabelFromOrderStatus = (data) => {
    if (orderStatus !== undefined) {
      return orderStatus.find((el) => el.value === data)?.label;
    }
  };

  // 상품 금액 구하기
  const productPrice = () => {
    let price = 0;
    orderList?.Detail?.forEach((product) => (price += Number(product.price)));

    return price;
  };

  // 택배 총 비용 구하기
  const deliveryPrice = () => {
    let delPrice = 0;
    orderList?.Detail?.forEach(
      (item) => (delPrice += Number(item.delivery_price))
    );
    return delPrice;
  };

  // 주문 취소 모달 보여주기
  const onClickOrderCancelModal = (ordernum) => {
    setCancelOrdernum(ordernum);
    setOpenCancelModal((prev) => !prev);
  };

  const onClickToDetail = (ename, pcode) => () => {
    router.push(`/products/${ename}/${pcode}/`);
  };

  // 영수증 링크 연결
  const onClickShowReceipt = async (ordernum) => {
    const body = {
      modes: "ReceiptView",
      ordernum: ordernum,
    };

    const res = await postCommonReceipt(body);

    if (res.status === 200) {
      if (res.data?.Code === "0000") {
        if (res.data?.Data?.Data?.url === "") {
          return failAlert("현재 영수증 정보가 없습니다.");
        } else {
          let link = document.createElement("a");
          link.href = res?.data?.Data?.Data.url;
          link.target = "_blank";
          link.click();
        }
      }

      if (res.data?.Code === "9999") {
        return failAlert(res.data.Data?.Msg);
      }
    } else {
      return failAlert(res.data.Data?.Msg);
    }
  };

  useEffect(() => {
    if (dummyList) {
      fetchDummyList();
    }
  }, [dummyList]);

  useEffect(() => {
    if (bannerList?.interview) {
      setInterviewBanner(
        bannerList.interview[random(0, bannerList.interview.length - 1)]
      );
    }
  }, [bannerList]);

  return (
    <>
      <Layout
        parent={"홈"}
        sub="주문 조회"
        pageTitle={SeoMeta.orderInquiry.title}
        pageDesc={SeoMeta.orderInquiry.description}
        pageKeyword={SeoMeta.orderInquiry.keywords}
      >
        <div className="page-content mt-50 pb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 m-auto">
                <div className="row">
                  <div className="col-lg-6 pr-30 d-none d-lg-block">
                    {interviewBanner && (
                      <img
                        className="border-radius-15"
                        src={interviewBanner?.P_FileUrl}
                        alt={interviewBanner.img_alt || "인터뷰 배너 이미지"}
                      />
                    )}
                  </div>
                  <div className="col-lg-5 col-md-8 m-auto">
                    <div className="login_wrap widget-taber-content background-white">
                      <div className="padding_eight_all bg-white">
                        <div className="heading_s1">
                          <h1 className="mb-30">주문 조회</h1>
                        </div>
                        <div className="inputs">
                          <FormInputRow>
                            <FormInputBasicSpan>주문번호</FormInputBasicSpan>
                            <FormInputBasicInput
                              placeholder="주문번호를 입력하세요."
                              onChange={onChangeOrderInfo("ordernum")}
                              type="text"
                            />
                          </FormInputRow>
                          <FormInputRow>
                            <FormInputBasicSpan>
                              주문조회 비밀번호
                            </FormInputBasicSpan>
                            <FormInputBasicInput
                              placeholder="비밀번호를 입력하세요."
                              onChange={onChangeOrderInfo("opass")}
                              type="password"
                            />
                          </FormInputRow>
                          <div className="form-group">
                            <button
                              className="btn btn-heading btn-block hover-up col-12 mt-20"
                              onClick={findOrder}
                            >
                              조회하기
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 주문 상세 정보 */}
            {orderList && orderList.Detail?.length > 0 && (
              <div className="row mt-50">
                <div className="col-lg-12">
                  <Details.Container>
                    <Details.Header>
                      <div className="order-num-date">
                        <span className="content">
                          주문번호 {orderList.Main?.ordernum} |{" "}
                        </span>
                        <span className="content">
                          주문일자 {orderList.Main?.wdate}
                        </span>
                        <span className="sm-content">
                          주문번호 {orderList.Main?.ordernum}{" "}
                        </span>
                        <span className="sm-content">
                          주문일자 {orderList.Main?.wdate}
                        </span>
                      </div>
                      <div
                        className="info-row cancel-btn d-flex"
                        style={{
                          width: "40%",
                          justifyContent: "end",
                          alignItems: "center",
                        }}
                      >
                        <span className="mr-10 font-lg">
                          주문 상태 :{" "}
                          {getLabelFromOrderStatus(orderList?.Main?.stats)}
                        </span>
                        {(orderList?.Main?.stats === "1" &&
                          (orderList?.Main?.paymethod === "bank" ||
                            orderList?.Main?.paymethod === "vbank")) ||
                        (orderList?.Main?.stats === "2" &&
                          (orderList?.Main?.paymethod !== "bank" ||
                            orderList?.Main?.paymethod !== "vbank")) ? (
                          <button
                            className="button bg-warning"
                            onClick={() =>
                              onClickOrderCancelModal(orderList?.Main?.ordernum)
                            }
                          >
                            주문취소
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </Details.Header>
                    <Details.ListWrapper>
                      {orderList &&
                        orderList.Detail?.map((order, i) => (
                          <Details.ProductSection key={i}>
                            <div className="product-content">
                              <div
                                className="img-section"
                                onClick={onClickToDetail(
                                  order?.ename,
                                  order?.pcode
                                )}
                              >
                                <img
                                  src={
                                    order.image
                                      ? order?.image
                                      : "/assets/imgs/vendor/vendor-1.png"
                                  }
                                />
                              </div>
                              <div className="info-section">
                                <div className="info-row">
                                  <span className="content product-name">
                                    {order.pname}
                                  </span>
                                </div>
                                <span className="info-row">
                                  <div className="content counts">
                                    <span className="supply_price mr-10">
                                      {priceComma(order.price)}원
                                    </span>
                                    |
                                    <span className="pl-10">
                                      {priceComma(order.cnt)}개
                                    </span>
                                  </div>
                                </span>
                                <span className="info-row">
                                  <div className="content">
                                    <span>
                                      {getLabelFromDeliveryList(
                                        order?.delivery
                                      )}
                                      {order?.deliverynum
                                        ? order?.deliverynum
                                        : ""}
                                    </span>
                                  </div>
                                </span>
                                <span className="info-row shipping-status">
                                  <span className="content">
                                    {getLabelFromOrderStatus(order?.stats)}
                                  </span>
                                </span>
                                {order?.stats === "4" ||
                                order?.stats === "5" ? (
                                  <div className="btn-section-md">
                                    <button
                                      className="button bg-warning"
                                      onClick={() =>
                                        onClickOrderTrackingModal(order)
                                      }
                                    >
                                      배송조회
                                    </button>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              {order?.stats === "4" || order?.stats === "5" ? (
                                <div className="btn-section">
                                  <button
                                    className="button bg-warning"
                                    onClick={() =>
                                      onClickOrderTrackingModal(order)
                                    }
                                  >
                                    배송조회
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </Details.ProductSection>
                        ))}
                      <Details.DeliverySection>
                        <div className="delivery-header">
                          <h5>배송지 정보</h5>
                        </div>
                        <div className="delivery-content">
                          <div className="info-section">
                            <div className="info-row">
                              <span className="title">받는 사람</span>
                              <span className="content">
                                {orderList.Main?.name}
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">휴대전화</span>
                              <span className="content">
                                {autoPhoneFormat(orderList.Main?.phone)}
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">주소</span>
                              <span className="content">
                                {orderList.Main?.addr?.doro_addr
                                  ? orderList.Main?.addr?.doro_addr
                                  : ""}{" "}
                                {orderList.Main?.addr?.detail_addr
                                  ? orderList.Main?.addr?.detail_addr
                                  : ""}
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">배송 메세지</span>
                              <span className="content">
                                {orderList.Main?.message
                                  ? orderList.Main?.message
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Details.DeliverySection>
                      <Details.PaymentsSection>
                        <div className="payments-header">
                          <h5>결제 정보</h5>
                        </div>
                        <div className="payments-content">
                          <div className="info-section">
                            <div className="info-row">
                              <span className="title">상품 금액</span>
                              <span className="content">
                                {priceComma(productPrice())} 원
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">배송비</span>
                              <span className="content">
                                {priceComma(deliveryPrice())} 원
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">결제 방법</span>
                              <span className="content">
                                {orderList?.Main?.paymethod_kor}
                              </span>
                            </div>
                            <div className="info-row">
                              <span className="title">총 결제 금액</span>
                              <span className="content">
                                {priceComma(orderList?.Main?.price)}원
                                <span className="ml-10">
                                  {orderList?.Main?.receipt}
                                  {orderList?.Main?.receipt_stats ===
                                    "발행" && (
                                    <span className="receipt-btn">
                                      <button
                                        className="btn btn-xs"
                                        onClick={(e) =>
                                          onClickShowReceipt(
                                            orderList?.Main?.ordernum
                                          )
                                        }
                                      >
                                        <i className="fi fi-rs-ballot" />
                                      </button>
                                    </span>
                                  )}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </Details.PaymentsSection>
                    </Details.ListWrapper>
                  </Details.Container>
                </div>
              </div>
            )}
          </div>
        </div>
      </Layout>
      {openOrderCancelModal && (
        <OrderCancelModal
          orderNum={cancelOrdernum}
          onClickOrderCancelModal={onClickOrderCancelModal}
          division={"store"}
        />
      )}
      {openTrackingModal && (
        <OrderTrackingModal
          orderData={selectedOrder}
          onClickOrderTrackingModal={onClickOrderTrackingModal}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
  bannerList: state.bannerList,
});

export default connect(mapStateToProps, null)(OrderSearchPage);
